import {LogOut} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ExitToAppIcon = createLucideIcon(LogOut, 'ExitToAppIcon');
